<div class="flex flex-col items-center w-full">
  <h1>Login</h1>

  <sdc-button
    className="disabled:opacity-30 !w-28 min-w-max h-10 disabled:hover:transform-none hover:scale-95 transition-transform"
    theme="theme-sdc"
    type="button"
    variant="primary"
    (onClick)="showPatron()">
    Show patron
  </sdc-button>
  @if (name$ | async; as name) {
    <p>Hello {{ name }}</p>
  }
  @if (patron) {
    <h1>
      {{ patron }}
    </h1>
  }
  @if ((isAuthenticated$ | async) === false) {
    <div>
      <sdc-button
        className="disabled:opacity-30 !w-28 min-w-max h-10 disabled:hover:transform-none hover:scale-95 transition-transform"
        theme="theme-sdc"
        variant="primary"
        (onClick)="signOut()">
        Sign out
      </sdc-button>
    </div>
  }
  <marquee direction="left">Login page bb</marquee>
</div>
